export class TabsService {
  HOME = 0;
  SEARCH = 1;
  MY_CLASSES = 2;
  // FAVORITES=3;
  BEAUTY = 3;
  PROFILE = 4;

  setBackgroundColor(isBeauty: boolean) {
    const meta = document.querySelector('meta[name="theme-color"]');
    if (isBeauty) {
      meta.setAttribute('content', '#ED6291');
    } else {
      meta.setAttribute('content', '#3878E8');
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.service.ts